let reasonsWrapper = $('#reasonsWrapper');

function moveStickyCTA() {
  const reasons = document.querySelector('#reasons');

  if (reasons.dataset.sticky !== undefined) {
    const stickyCTA = document.querySelector('#stickyCTA');
    const position = document.querySelectorAll('.reasons__item');

    position[reasons.dataset.sticky - 1].after(stickyCTA)
  }
}
if ($('#stickyCTA').length) {
  moveStickyCTA();
}

function expandContentDefault(el) {
  if (!el.hasClass('toCollapse')) {
    el.addClass('toCollapse').next('.reasons__content').addClass('toExpand');
  }
}

function expandContentCarousel(el) {
  let collapsibleContent = el.attr('data-collapsible-content');

  // console.log('collapsibleContent', collapsibleContent);

  el.find('span').html(collapsibleContent);
  el.addClass('toCollapse').next('.reasons__content').addClass('toExpand');
}

function collapseContentCarousel(el) {
  let expandableContent = el.attr('data-expandable-content');

  // console.log('expandableContent', expandableContent);

  el.find('span').html(expandableContent);
  el.removeClass('toCollapse').next('.reasons__content').removeClass('toExpand');
}

/**
 * show content and hide trigger only if not on carousel
 */
if (!$(reasonsWrapper).length) {
  $('.reasons__triggerContent').on('click', function () {
    let trigger = $(this);

    expandContentDefault(trigger)
  });
}

if ($(reasonsWrapper).length) {
  $('.reasons__triggerContent').on('click', function () {
    let trigger = $(this);

    if (trigger.hasClass('toCollapse')) {
      collapseContentCarousel(trigger);
    } else {
      expandContentCarousel(trigger);
    }
  });
}

/**
 * Innitiate slick if $('#reasonsWrapper')
 */
if ($(reasonsWrapper).length) {
  $(reasonsWrapper).slick({
    mobileFirst: true,
    slidesToShow: 1.05,
    dots: true,
    arrows: false,
    speed: 300,
    initialSlide: 0,
    infinite: false,
    adaptiveHeight: true,
    centerMode: false,
    responsive: [
      {
        breakpoint: 374,
        settings: {
          slidesToShow: 1.15
        }
      },
      {
        breakpoint: 413,
        settings: {
          slidesToShow: 1.27 //- try to get a minimum of 290px and a max of 390
        }
      },
      {
        breakpoint: 513,
        settings: {
          slidesToShow: 1.5
        }
      },
      {
        breakpoint: 599,
        settings: {
          slidesToShow: 1.75
        }
      },
      {
        breakpoint: 549,
        settings: {
          slidesToShow: 1.95
        }
      },
      {
        breakpoint: 619,
        settings: {
          slidesToShow: 2.15
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2.5
        }
      },
      {
        breakpoint: 919,
        settings: {
          slidesToShow: 2.95
        }
      },
      {
        breakpoint: 1024,
        settings: "unslick"
      }
    ]
  });
}
